<template>
  <div
    :class="[
      'form-group mb-0 input-wrapper',
      label ? 'justify-content-start' : 'justify-content-between',
      customClass.containerClass,
    ]"
  >
    <label :for="id" :class="customClass.labelClass">{{ label }}</label>
    <div>
      <div class="d-flex">
        <div v-if="showPrefixLabel" class="side-label prefix-label">
          <slot name="prefix-label"> </slot>
        </div>
        <input
          :id="id"
          :type="type"
          :class="[
            'form-control',
            showPrefixLabel ? 'input-with-prefix' : '',
            showSuffixLabel ? 'input-with-suffix' : '',
            customClass.inputClass,
          ]"
          :placeholder="placeholder"
          :value="value"
          @blur="onblur"
          @input="onchange"
          :disabled="disabled"
        />
        <div v-if="showSuffixLabel" class="side-label suffix-label">
          <slot name="suffix-label"> </slot>
        </div>
      </div>
      <small class="text-danger m-0" v-if="currentError">{{
        currentError
      }}</small>
    </div>
  </div>
</template>

<script>
import { validateEmail } from "../../utils";

export default {
  props: {
    customClass: {
      type: Object,
      default: () => ({ containerClass: "", labelClass: "", inputClass: "" }),
    },
    id: { type: String, required: true },
    value: { type: String, required: true },
    placeholder: { type: String, default: "", required: false },
    error: { type: String, default: "", required: false },
    label: { type: String, default: "", required: false },
    type: { type: String, default: "text", required: false },
    required: { type: Boolean, default: false },
    showPrefixLabel: { type: Boolean, default: false },
    showSuffixLabel: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    parser: { type: Function, default: null, required: false },
  },
  data() {
    return {
      currentError: "",
    };
  },
  computed: {},
  methods: {
    onchange(event) {
      if (event.target.value) this.currentError = "";
      const newValue = this.parser
        ? this.parser(event.target.value)
        : event.target.value;
      this.$emit("change", newValue);

      event.target.value = newValue;
    },
    onblur(event) {
      if (this.required && !event.target.value) {
        this.currentError = "This field is required";
      }
      if (this.type === "email") {
        const validEmail = validateEmail(event.target.value);
        if (!validEmail) {
          this.currentError = "Email is not valid";
        }
      }

      const newValue = this.parser
        ? this.parser(event.target.value)
        : event.target.value;
      this.$emit("blur", newValue);

      event.target.value = newValue;
    },
  },
  watch: {
    error(value) {
      this.currentError = value;
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  border-radius: 6px;
  height: 40px;
  font-size: 1rem;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}

.text-muted,
input::placeholder {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}

.prefix-label {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.suffix-label {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.input-with-prefix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}

.input-with-suffix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.side-label {
  background-color: #fafafa;
  border: 1px solid #d1d9e2;
  color: #2e3646;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  font-size: 1rem;
  height: 40px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputText.vue